"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Person_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Person = void 0;
const XSDDate_1 = require("lincd-xsd/lib/shapes/XSDDate");
const models_1 = require("lincd/lib/models");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const schema_1 = require("../ontologies/schema");
const package_1 = require("../package");
const Place_1 = require("./Place");
const Thing_1 = require("./Thing");
const PostalAddress_1 = require("./PostalAddress");
let Person = Person_1 = class Person extends Thing_1.Thing {
    get givenName() {
        return this.getValue(schema_1.schema.givenName);
    }
    set givenName(val) {
        this.overwrite(schema_1.schema.givenName, new models_1.Literal(val));
    }
    get familyName() {
        return this.getValue(schema_1.schema.familyName);
    }
    set familyName(val) {
        this.overwrite(schema_1.schema.familyName, new models_1.Literal(val));
    }
    get alternateName() {
        return this.getValue(schema_1.schema.alternateName);
    }
    set alternateName(val) {
        this.overwrite(schema_1.schema.alternateName, new models_1.Literal(val));
    }
    get gender() {
        return this.getValue(schema_1.schema.gender);
    }
    set gender(val) {
        this.overwrite(schema_1.schema.gender, val ? new models_1.Literal(val) : null);
    }
    get telephone() {
        return this.getValue(schema_1.schema.telephone);
    }
    set telephone(val) {
        this.overwrite(schema_1.schema.telephone, new models_1.Literal(val));
    }
    get birthDate() {
        return this.hasProperty(schema_1.schema.birthDate)
            ? XSDDate_1.XSDDate.toNativeDate(this.getOne(schema_1.schema.birthDate))
            : null;
    }
    set birthDate(nativeDate) {
        this.overwrite(schema_1.schema.birthDate, nativeDate ? XSDDate_1.XSDDate.fromNativeDate(nativeDate).node : null);
    }
    get age() {
        if (this.hasProperty(schema_1.schema.birthDate) === false)
            return null;
        var today = new Date();
        var birthDate = this.birthDate;
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }
    get birthPlace() {
        return this.getOneAs(schema_1.schema.birthPlace, Place_1.Place);
    }
    set birthPlace(val) {
        this.overwrite(schema_1.schema.birthPlace, val ? val.node : null);
    }
    //TODO: schema.hasOccupation -> schema:Occupation (shape to be created)
    get hasOccupation() {
        return this.getValue(schema_1.schema.hasOccupation);
    }
    set hasOccupation(val) {
        this.overwrite(schema_1.schema.hasOccupation, new models_1.Literal(val));
    }
    get homeLocation() {
        return this.getAllAs(schema_1.schema.homeLocation, Place_1.Place);
    }
    get honorificPrefix() {
        return this.getValue(schema_1.schema.honorificPrefix);
    }
    set honorificPrefix(val) {
        this.overwrite(schema_1.schema.honorificPrefix, new models_1.Literal(val));
    }
    get areaServed() {
        return this.getOneAs(schema_1.schema.areaServed, Place_1.Place);
    }
    set areaServed(val) {
        this.overwrite(schema_1.schema.areaServed, val ? val.node : null);
    }
    get description() {
        return this.getValue(schema_1.schema.description);
    }
    set description(val) {
        this.overwrite(schema_1.schema.description, new models_1.Literal(val));
    }
    getNewUniqueID() {
        const person = Person_1.getLocalInstances();
        return person.size + 1;
    }
    get address() {
        return this.getOneAs(schema_1.schema.address, PostalAddress_1.PostalAddress);
    }
    set address(val) {
        this.overwrite(schema_1.schema.address, val.namedNode);
    }
};
Person.targetClass = schema_1.schema.Person;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.givenName,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "givenName", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.familyName,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "familyName", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.alternateName,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "alternateName", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.gender,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "gender", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.telephone,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "telephone", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.birthDate,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], Person.prototype, "birthDate", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.birthPlace,
        required: false,
        shape: Person_1,
        maxCount: 1,
    }),
    __metadata("design:type", Place_1.Place),
    __metadata("design:paramtypes", [Place_1.Place])
], Person.prototype, "birthPlace", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.hasOccupation,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "hasOccupation", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.homeLocation,
        shape: Place_1.Place,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Person.prototype, "homeLocation", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.areaServed,
        required: false,
        shape: Person_1,
        maxCount: 1,
    }),
    __metadata("design:type", Place_1.Place),
    __metadata("design:paramtypes", [Place_1.Place])
], Person.prototype, "areaServed", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.description,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "description", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.address,
        maxCount: 1,
    }),
    __metadata("design:type", PostalAddress_1.PostalAddress),
    __metadata("design:paramtypes", [PostalAddress_1.PostalAddress])
], Person.prototype, "address", null);
Person = Person_1 = __decorate([
    package_1.linkedShape
], Person);
exports.Person = Person;
//# sourceMappingURL=Person.js.map